import React from 'react';
import './OurWorkPhilosophy.css';
import siteConfig from '../../configuration/siteConfiguration';

function OurWorkPhilosophy() {
  const baseUrl = `${siteConfig.assetBaseUrl}/icons/careers/our-work-philosophy`;
  return (
    <section className="our-work-philosophy">
      <div className="wave-bg">
        <img src="/images/wave.svg" alt="" />
      </div>
      <div className="OWP-container">
        <div className="content-wrapper">
          <div className="left-content">
            <p className="section-label">— OUR WORK PHILOSOPHY</p>
            <h2>We care just as much about how we work as what we build</h2>
            <div className="intro-text-wrapper">
              <p className="intro-text">
                Here, you don't just do your best work — you become your best self
                <span className="quote-marks"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                  <path d="M0 10L2.54545 0H5.81818L4.36364 10H0ZM6.18182 10L8.72727 0H12L10.5455 10H6.18182Z" fill="#FFE7CC" />
                </svg></span>
              </p>
            </div>
          </div>

          <div className="values-grid">
            <div className="value-item">
              <div className="icon-wrapper">
                <img src={`${baseUrl}/people-before-process.svg`} alt="People before Process icon" />
              </div>
              <div className="text-content">
                <h3>People before Process</h3>
                <p>We're building a team you'd want to work with even if the product didn't exist</p>
              </div>
            </div>

            <div className="value-item">
              <div className="icon-wrapper">
                <img src={`${baseUrl}/excellence-with-empathy.svg`} alt="Excellence with Empathy icon" />
              </div>
              <div className="text-content">
                <h3>Excellence with Empathy</h3>
                <p>We build high-quality systems, but never at the cost of burnout or belonging</p>
              </div>
            </div>

            <div className="value-item">
              <div className="icon-wrapper">
                <img src={`${baseUrl}/autonomy-with-accountability.svg`} alt="Autonomy with Accountability icon" />
              </div>
              <div className="text-content">
                <h3>Autonomy with Accountability</h3>
                <p>You'll have freedom, trust, and real ownership from Day 1</p>
              </div>
            </div>

            <div className="value-item">
              <div className="icon-wrapper">
                <img src={`${baseUrl}/grow-with-the-company.svg`} alt="Grow with the Company icon" />
              </div>
              <div className="text-content">
                <h3>Grow with the Company</h3>
                <p>As Cognitva scales, you grow in skill, in impact, and in leadership.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurWorkPhilosophy;